import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Label } from "../../pages/libraries/components/Label";
import "./rowlist.scss";

interface IRowList {
  id: string;
  title: React.ReactNode;
  labels?: any;
  description: string;
  indicators: React.ReactNode;
  actions: React.ReactNode;
  rightInformation: React.ReactNode;
  type: string;
}

const LabelsList = ({ labels }: { labels: any }) => {
  return labels.map((label: any) => (
    <div className="mr-1">
      <Label name={label.name} categ={label.categ} color={label.color} />
    </div>
  ));
};

const RowList = ({
  title,
  description,
  indicators,
  actions,
  rightInformation,
  labels,
  type,
  id,
}: IRowList) => {
  const [seeActions, setSeeAction] = useState<Boolean>(false);
  const navigate = useNavigate();

  return (
    <>
      <div
        className="rowList justify-content-between flex flex-wrap cursor-pointer"
        onMouseEnter={() => setSeeAction(true)}
        onMouseLeave={() => setSeeAction(false)}
        onClick={() => {
          if (type === "topologies") navigate(`/treatments/editor?t=${id}`);
        }}
      >
        <div
          className={`sectionLeft align-items-center justify-content-center`}
        >
          <div className="mb-2 displayWrap align-items-center">
            <div className="mr-2">{title}</div>
            {labels && (
              <div className="displayWrap">
                {" "}
                <LabelsList labels={labels} />
              </div>
            )}
          </div>
          <div className="description mb-2">{description}</div>
          <div className="mb-2">{indicators}</div>
        </div>
        <div className="flex flex-column justify-content-center">
          {seeActions && (
            <div
              onClick={(e) => {
                e.stopPropagation();
              }}
              className="actions flex mb-2"
            >
              {actions}
            </div>
          )}
          <div className="flex rightComponent">{rightInformation}</div>
        </div>
      </div>
    </>
  );
};

export default RowList;
